import { alpha, type Theme } from "@mui/material/styles";
import type { AppDashboardsPageStyles } from "../types";

export function buildDashboardsPageStyles(theme: Theme): AppDashboardsPageStyles {
  return {
    detailRoot: {
      display: "flex",
      flexDirection: "column",
      gap: 1.5,
      minHeight: 0,
      pt: 1.5,
      bgcolor: "transparent",
    },
    detailHeaderPaper: {
      borderBottom: "1px solid",
      borderColor: "divider",
      bgcolor: "background.paper",
      px: { xs: 1.5, md: 2 },
      py: 1,
    },
    headerTitleRow: { flex: 1, minWidth: 0 },
    backButton: { minWidth: 40, px: 1 },
    breadcrumbCaption: { display: "block", lineHeight: 1.2, cursor: "pointer" },
    titleRow: { minWidth: 0 },
    renameField: { maxWidth: { xs: 220, md: 480 }, minWidth: 160 },
    dashboardTitle: { maxWidth: { xs: 220, md: 480 } },
    modeChip: { fontWeight: 600 },
    printArea: { px: { xs: 0.5, md: 0 }, py: 0 },
    gridSection: { flex: 1, px: 0, pb: 2, minWidth: 0 },
    gridStack: { width: "100%", minWidth: 0, alignItems: "flex-start" },
    gridContainer: { flex: 1, minWidth: 0, overflow: "hidden" },
    shareUrlText: { flex: 1, wordBreak: "break-all" },
    shareLinksDivider: { mb: 1.5 },
    shareLinksTitle: { mb: 1 },
    shareLinkPaper: {
      p: 1.25,
      mb: 1,
      bgcolor: alpha(theme.palette.primary.main, 0.02),
    },
    shareLinkUrlBox: { flex: 1, minWidth: 0 },
    shareLinkMonospace: { fontFamily: "monospace", fontSize: 12, wordBreak: "break-all" },
    listPresetCardContent: { py: 1.5 },
    layoutPresetCard: (selected: boolean) => ({
      borderColor: selected ? "primary.main" : "divider",
      bgcolor: selected ? alpha(theme.palette.primary.main, 0.06) : "background.paper",
    }),
  };
}
